import React from 'react';
/* import ReactDOM from 'react-dom'; */
import './registrarEmpleado.scss';
import AppRegistro from './AppRegistro';

function RegistroEmpleado() {
  return (
    <div>
      <AppRegistro />
    </div>
  );
}

export default RegistroEmpleado;
